package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_03_29_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The marsh is full of mosquitoes, black flies, and other nasty bugs. The heroes break camp and head toward Seshiss — afterwards they will need to head west. Korvis suggests they can expect to cover 20 miles per day as long as they stay on the path.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Korvis explains that he is a Shadowfell but is not evil. Caper confirms that he has a good soul. Halfway through the day, the heroes pass near a shrine to Ellewen, which Korvis stops at to pray and seems energized. Caper hunts in the evening and makes the heroes a rabbit stew.")
    }
}
